interface IBanner {
	color: string,
	bgColor: string,
}
export interface IItem {
	bannerText: string,
	url: string,
	date: string,
	title: string,
	preamble: string,
	imgUrl: string,
	bannerColor: IBanner;
}

export interface ITag {
	name: string,
	options: ITagOption[],
}

export interface ISort {
	name: string,
	title: string,
}

export interface ITagOption extends ISort {
	selected: boolean,
}

export interface IBlogName extends ITagOption {
}

export interface ISelectedFilter {
	name: string,
	option: ITagOption,
}

export interface IState {
	articleForm: string,
	items: IItem[],
	total: number,
	numberToShow: number,
	initialNumberToShow: number,
	blogNames: ITagOption[],
	sort: ISort[],
	loading: boolean,
	url: string,
	selectedSort: string,
	selectedTypes: string,
	selectedBlogs: string,
	start: string,
	end: string,
	operations: ITagOption[],
	//professions: ITagOption[],
	subjects: ITagOption[],
	themes: ITagOption[],
	selectedOperations: string,
	//selectedProfessions: string,
	selectedSubjects: string,
	selectedThemes: string,
	tags: ITag[],
}

const deafultState: IState = {
	articleForm: '',
	items: [],
	total: 0,
	numberToShow: 9,
	initialNumberToShow: 9,
	selectedTypes: '',
	sort: [],
	blogNames: [],
	selectedBlogs: '',
	loading: false,
	url: '',
	selectedSort: '',
	start: '',
	end: '',
	operations: [],
	//professions: [],
	subjects: [],
	themes: [],
	selectedOperations: '',
	//selectedProfessions: '',
	selectedSubjects: '',
	selectedThemes: '',
	tags: [],
}

export default deafultState;
